<div *ngIf="loading" class="spinner-container">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
